import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { IconProps } from 'shared';

import media from '../../utils/Breakpoints';
import { colors } from '../../utils/config';

const StyledSwitch = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 50px;
`;

const Text = styled.label`
	color: ${colors.black};
	display: flex;
	flex-grow: 1;
	align-items: center;
	padding: 12px 0;
	height: 100%;

	&:hover {
		cursor: pointer;
	}

	&.icon::before {
		content: '';
		display: block;
		flex-grow: 0;
		flex-shrink: 0;
		margin-right: 5px;
		width: 30px;
		height: 30px;
		background: center center no-repeat transparent;
	}

	&.icon-freizeit::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.freizeit.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-essentrinken::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.essentrinken.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-kultur::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.kultur.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}

	&.icon-sehenswuerdigkeiten::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.sehenswuerdigkeiten.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-rundumsrad::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.rundumsrad.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-bildungseinrichtungen::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.bildungseinrichtungen.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-krankenhaeuserkliniken::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.krankenhaeuserkliniken.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-verbaendevereine::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.verbaendevereine.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}

	&.icon-stella::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.stella.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-car2go::before,
	&.icon-sharenow::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.sharenow.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-flinkster::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.flinkster.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-regiorad::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='${IconProps.regiorad.viewBox}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.regiorad.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-stadtmobil::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.stadtmobil.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-free2move::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='${IconProps.free2move.viewBox}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.free2move.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-ökostadtrenningen::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='${IconProps.ökostadtrenningen.viewBox}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.ökostadtrenningen.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-dott::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='${IconProps.dott.viewBox}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.dott.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-lime::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='${IconProps.lime.viewBox}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.lime.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-bolt::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='${IconProps.bolt.viewBox}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.bolt.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-voi::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='${IconProps.voi.viewBox}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.voi.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-zeus::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='${IconProps.zeus.viewBox}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.zeus.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-nextbike::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='${IconProps.nextbike.viewBox}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.nextbike.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}
	&.icon-deer::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='${IconProps.deer.viewBox}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.deer.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}

	&.icon-ausflugstipps::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.tips.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}

	&.icon-haltestellen::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.stopWithOutline.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}

	&.icon-stadtticket::before {
		background-image: url("${IconProps.citytickets.svg}");
	}
	&.icon-rbahn::before {
		${'' /* this is only here because of css parsing bug */}
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.rbahn.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}

	&.icon-linien::before {
		background-image: url("${IconProps.stopLines.svg}");
	}
	&.icon-rbahn::before {
		${'' /* this is only here because of css parsing bug */}
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.rbahn.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}

	&.icon-rbahn::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.rbahn.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}

	&.icon-sbahn::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.sbahn.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}

	&.icon-stadtbahn::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.ubahn.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}

	&.icon-bus::before {
		background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.bus.path}' fill='%2398AAB3'/%3E%3C/svg%3E");
	}

	&.icon-parkride::before {
		background-image: url("data:image/svg+xml,%3Csvg width='46' height='30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.parkAndRide.path}' fill='%2398AAB3' transform='translate(6, -2)'/%3E%3C/svg%3E");
	}

	&.icon-pr::before {
		background-image: url("data:image/svg+xml,%3Csvg width='46' height='30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='${IconProps.parkAndRide.path}' fill='%2398AAB3' transform='translate(6, -2)'/%3E%3C/svg%3E");
	}
`;

const Button = styled.label`
	display: block;
	position: relative;
	background-color: ${colors.grayblue};
	border-radius: 14px;
	cursor: pointer;
	flex-grow: 0;
	flex-shrink: 0;
	width: 42px;
	height: 22px;
	margin-left: 16px;
	transition: background-color 0.4s;

	${media.lg`
		width: 52px;
		height: 28px;
		margin-left: 24px;
	`}

	&::before {
		content: '';
		position: absolute;
		background-color: ${colors.white};
		border-radius: 50%;
		height: 18px;
		width: 18px;
		left: 2px;
		top: 2px;
		transition: transform 0.4s;

		${media.lg`
			height: 24px;
			width: 24px;
		`}
	}
`;

const Input = styled.input.attrs({ type: 'checkbox' })`
	opacity: 0;
	width: 0;
	height: 0;

	&:checked + ${Button} {
		background-color: ${colors.cyandark};

		&::before {
			transform: translateX(20px);

			${media.lg`
				transform: translateX(24px);
			`}
		}
	}
`;

class Switch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isChecked: false,
		};
	}

	componentDidMount() {
		this.setCheckedState(this.props.defaultChecked);
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (
			nextProps.defaultChecked !== this.props.defaultChecked ||
			nextState.isChecked !== this.state.isChecked
		) {
			return true;
		}
		return false;
	}

	componentDidUpdate() {
		this.setCheckedState(this.props.defaultChecked);
	}

	setCheckedState = isChecked => {
		this.setState({ isChecked });
	};

	toggleState = () => {
		if (this.props.onChange) {
			this.props.onChange(!this.state.isChecked);
		}

		this.setState(prevState => ({
			isChecked: !prevState.isChecked,
		}));
	};

	render() {
		const { id, value, label, icon } = this.props;
		const { isChecked } = this.state;

		return (
			<StyledSwitch>
				<Text htmlFor={id} className={icon ? `icon icon-${icon}` : ''}>
					<span>{label}</span>
				</Text>
				<Input
					type="checkbox"
					checked={isChecked}
					id={id}
					value={value}
					onChange={e => {
						this.toggleState(e);
					}}
				/>
				<Button htmlFor={id} />
			</StyledSwitch>
		);
	}
}

Switch.propTypes = {
	defaultChecked: PropTypes.bool,
	id: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	icon: PropTypes.string,
	onChange: PropTypes.func,
};

Switch.defaultProps = {
	icon: '',
	defaultChecked: false,
};

export default Switch;
